import { push } from 'router'
import { installUnauthorizedInterceptor } from 'apiv2/unauthorizedInterceptor'
import { sessionLogout } from './session-actions'

// Local sign-out (same as after changePassword) and back to the sign-in page, no page reload. Only while a user is still
// signed in, so several 401s arriving together sign out once.
export const handleSessionExpired = store => () => {
  if (!store.getState().session?.user) return
  store.dispatch(sessionLogout())
  push('/auth/sign-in')
}

export const installSessionExpiredHandling = store => installUnauthorizedInterceptor(handleSessionExpired(store))
